import api from "@/api/index";
import restfulApi from "@/api/restfulApi";

/**
 * @public
 * @param {Object} loginData
 */
const login = loginData => {
  return api.post(restfulApi.getLink('token', 'POST'), loginData)
    .then(response => {
      if (response.data.access.length > 0 && response.data.refresh.length > 0) {
        return ({
          access: response.data.access,
          refresh: response.data.refresh
        })
      }
    })
    .catch(reason => Promise.reject(reason))
}

/**
 * Отправка тестового запроса для проверки токенов
 * @public
 */
const checkAuth = () => {
  return api.get(restfulApi.getRoot())
    .then(response => {
      if (response === false) {
        return false
      }
      if (response.links && Array.isArray(response.links)) {
        throw response
      }
      if (response && response.status === 200) {
        return response.data
      }
      throw new Error()
    })
}

export default {
  login,
  checkAuth
}
